import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle, ChalkActionButton } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";
import { toast } from "sonner";

export default function AdminJobs() {
  const navigate = useNavigate();
  const [data, setData] = useState({ queue: null, jobs: [] });

  async function load() {
    const d = await api.adminJobs();
    setData(d);
  }
  useEffect(() => { load(); const t = setInterval(load, 3000); return () => clearInterval(t); }, []);

  async function fire() {
    await api.adminTestJob();
    toast.success("Test job queued.");
    load();
  }

  return (
    <>
      <DarkHeader eyebrow="Admin" title="Background jobs" subtitle={data.queue ? `Queue ${data.queue.running ? "running" : "stopped"} · ${Object.entries(data.queue.counts || {}).map(([k, v]) => `${k}:${v}`).join(" · ")}` : "Loading"} right={<BackButton onClick={() => navigate(-1)} />} />
      <div style={{ padding: "0 18px 24px" }}>
        <ChalkActionButton testId="fire-test-job" variant="ghost" label="Fire test job" onClick={fire} />
        <SectionTitle label="Recent jobs" />
        {data.jobs.map((j) => (
          <ChalkCard key={j.id} style={{ marginTop: 8 }} data-testid={`job-${j.id}`}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: "var(--chalk-board)" }}>{j.name}</div>
              <div style={{ fontSize: 11, color: "var(--chalk-muted)" }}>attempts {j.attempts}/{j.max_attempts}</div>
            </div>
            <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 4 }}>
              status: {j.status}{j.last_error ? ` · err: ${j.last_error}` : ""}
            </div>
          </ChalkCard>
        ))}
      </div>
    </>
  );
}
